import { useState } from 'react';
import { Popover } from '@pocketlaw/tetris';
import { PopoverContent } from './PopoverContent';
export function ProjectDetailsPopover(props) {
    const { projectId, children, lockGroupId } = props;
    const [hover, setHover] = useState(false);
    const handleMouseOver = () => setHover(true);
    const handleMouseOut = () => setHover(false);
    return (<Popover padding={0} offset={-4} shadow="300" placement="left-start" open={hover} onClose={handleMouseOut} trapFocus={false} target={
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <div onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
          {children}
        </div>} lockGroupId={lockGroupId}>
      <PopoverContent projectId={projectId}/>
    </Popover>);
}
